import { createComponents } from '@vfde-brix/ws10/core';
import { createButtonLink } from '@vfde-brix/ws10/button-link';

const SELECTOR_STEPPER_BUTTON = '.pathfinder-stepper-button';

/**
 * Creates the Brix Button Link components for each stepper button.
 * @param onClick Business logic of the button link elements.
 * @returns WS10 Button Link components.
 */
export const mountStepperButtons = (onClick: () => void) =>
    createComponents(SELECTOR_STEPPER_BUTTON, createButtonLink, { onClick });
